// extracted by mini-css-extract-plugin
export default {"mainContainer":"styles_mainContainer__Yn0HP","bodyContainer":"styles_bodyContainer__n4XMu"};